import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useCallback, useContext, useEffect, useState } from "react";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import ProviderLogoByWidgetType from "../Playground/ProviderLogoByWidgetType";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { ALLOWED_WIDGETS } from "./constants";
import PaginatedSelect from "../PaginatedSelect/PaginatedSelect";
export default function CampaignFields({ watch, setValue, register, errors }) {
  const baseUrl = getHostDomain();
  const agency = useContext(AgencyContext);
  const { cardBg: bg } = agency;
  const [widgets, setWidgets] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const widgetOptions = widgets.map((widget) => ({
    value: widget,
    label: `${widget.name} [${widget.widget_type}]`,
  }));
  const getWidgets = useCallback(async (pageNum) => {
    setLoading(true);
    const response = await fetchController(
      baseUrl + `/api/v1/widget/get_my_details?size=100&page=${pageNum}`
    );

    setWidgets((prev) => [
      ...prev,
      ...response.data.items.filter((widgetItem) =>
        ALLOWED_WIDGETS.includes(widgetItem.widget_type)
      ),
    ]);
    setHasMore(response.data.pages !== pageNum);
    setLoading(false);
  }, []);

  useEffect(() => {
    getWidgets(page);
  }, [page]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: bg,
    }),
    menu: (base) => ({
      ...base,
      background: bg,
    }),
    menuList: (base) => ({
      ...base,
      background: bg,
    }),
  };

  return (
    <>
      <FormControl isInvalid={errors.widget} isRequired>
        <FormLabel
          gap={3}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-start"}
        >
          <span>Widget</span>
          <ProviderLogoByWidgetType
            widgetType={watch("widget")?.value.widget_type}
          />
        </FormLabel>
        <PaginatedSelect
          autoFocus
          {...register("widget", {
            required: true,
          })}
          value={watch("widget")}
          onChange={(selectedWidget) => {
            setValue("widget", selectedWidget);
          }}
          options={widgetOptions}
          styles={customStyles}
          hasMore={hasMore}
          isLoading={loading}
          onLoadMore={() => {
            setPage((prev) => prev + 1);
          }}
        />
        <FormErrorMessage>
          {errors.widget?.type === "required" ? "Widget is required" : null}
        </FormErrorMessage>
      </FormControl>
      {watch("widget") && watch("widget").value?.widget_type === "whatsapp" ? (
        <FormControl isInvalid={errors.message} isRequired>
          <FormLabel>Message</FormLabel>
          <Textarea
            value={watch("message")}
            {...register("message", {
              required: true,
            })}
          />
          <FormErrorMessage>
            {errors.message?.type === "required" ? "Message is required" : null}
          </FormErrorMessage>
        </FormControl>
      ) : null}
    </>
  );
}
